import utilsService from '@/app/helpers/utilsService';
import fetchWrapper from '../fetchWrapper';

const BASE_URL = process.env.BASE_URL;

interface GetTopPostsParams {
    // limit?: number;
    cursor?: string | null;
    perPage?: number;
    signal?: AbortSignal;
    ownerId?: string | number; // Add owner_id to filter hidden posts
}

interface BannersDetailParams {
    signal?: AbortSignal;
    page: 'home' | 'attendance' | 'roulette' | 'quiz';
    position: 'top' | 'under-top';
}

async function getBanners({ page, position, signal }: BannersDetailParams): Promise<any> {
    try {
        const basePath = 'banners';
        const params = {
            page: page,
            position: position,
        };

        const url = utilsService.constructUrlWithParams(basePath, params);

        const response = await fetchWrapper.get(url, { signal });
        return response;
    } catch (error) {
        throw error;
    }
}
// U6-14: 홈에서 배너가 실제로 노출됐을 때 view_count 를 올린다
async function trackBannerView(bannerId: number): Promise<any> {
    try {
        const response = await fetchWrapper.post(`${BASE_URL}/banners/${bannerId}/view`);
        return response;
    } catch (error) {
        // Silently fail - don't disrupt user experience
        console.debug('Banner view tracking failed:', error);
        throw error;
    }
}

async function getExpert({ signal }: { signal?: AbortSignal }): Promise<any> {
    try {
        const response = await fetchWrapper.get(`${BASE_URL}/home/expert`, { signal });
        return response;
    } catch (error) {
        throw error;
    }
}

async function getTopPosts({ cursor = null, perPage = 20, signal, ownerId }: GetTopPostsParams): Promise<any> {
    try {
        const basePath = 'home/top-articles';
        const params: any = {
            cursor: cursor,
            per_page: perPage,
        };

        if (ownerId) {
            params.owner_id = ownerId;
        }

        const url = utilsService.constructUrlWithParams(basePath, params);

        const response = await fetchWrapper.get(url, { signal });
        return response;
    } catch (error) {
        throw error;
    }
}

async function getFaqHome(signal: AbortSignal): Promise<any> {
    try {
        const response = await fetchWrapper.get(`${BASE_URL}/home/faqs`, { signal });
        return response;
    } catch (error) {
        throw error;
    }
}

export const homeService = {
    getTopPosts,
    getBanners,
    trackBannerView,
    getExpert,
    getFaqHome,
};
